import axios from "axios";
import { useAuthStore } from "../state/pinia";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

api.interceptors.request.use(
  async (config) => {
    const authStore = useAuthStore();

    // Attach Authorization token if available
    const token = authStore.getToken;
    if (token && config.headers) {
      config.headers["Authorization"] = token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
